import { render, staticRenderFns } from "./SelectionInput.vue?vue&type=template&id=b3edf226&"
import script from "./SelectionInput.vue?vue&type=script&lang=js&"
export * from "./SelectionInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectionInput.vue?vue&type=style&index=0&id=b3edf226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports